import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import Services from "@/sites/data/services";
import { columns } from "./table-config";

export function CalculationFormServices() {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="flex-1 h-full">
			<ContentCard
				title={t("organization.data.services")}
				icon={icon("Table")}
				variant="plain"
				className="h-full"
				contentClassName="h-full"
			>
				<Services
					withContentBox={false}
					className="h-full"
					columns={columns}
					initialPinningState={{ start: ["drag-handle"] }}
				/>
			</ContentCard>
		</div>
	);
}
